import './App.css';
import {useHistory} from "react-router-dom";
import {useState} from "react";
import style from './App.css'

function Top() {
  const history = useHistory()
  const [end, setEnd] = useState('')

  const toInquiry = () => {
    history.push('/inquiry', {end})
  }

  return (
    <>
      <div className="App">
        <header className="App-header">
          <h1>東西会おみぐじ</h1>
        </header>
        <div>
          <div>
            抽選日時を設定してください。
          </div>
          <div className={style.messagePanel}>
            <input className={style.inputDate} value={end} type={'datetime-local'} onInput={(e) => setEnd(e.target.value)}/>
          </div>
          <div className='startPanel'>
            <button disabled={end === ''} onClick={toInquiry}>抽選開始</button>
          </div>
        </div>
      </div>
    </>
  );
}

export default Top;
